import React, { useEffect } from "react";

import { AuthFlow } from "components/AuthComponents/shared";
import LoadingSpinner from "components/Lottie/loading";
import PropTypes from "prop-types";
import { authStatusViaOktaSession } from "lib/oauth";
import styled from "styled-components";
import { useRouter } from "next/router";

const Centered = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
`;

const AuthLanding = ({ userType }) => {
  const {
    query: { error, next, email },
    replace,
  } = useRouter();

  useEffect(() => {
    (async () => {
      const status = await (async () => {
        try {
          return await authStatusViaOktaSession();
        } catch {
          return undefined;
        }
      })();
      const ut = { vendor: "provider" }[userType] ?? userType;
      const params = (() => {
        const go =
          next ??
          {
            customer: "/",
            vendor: "/provider/post-login-redirect",
            admin: "/admin/user-profile",
          }[userType];
        return Object.fromEntries(
          Object.entries({ ...(status ?? {}), next: go, email, error }).filter(
            ([, v]) => v
          )
        );
      })();

      if (!status || error || status.okta_groups.length === 0) {
        await replace({
          pathname: `/${ut}/auth/sessionless`,
          query: params,
        });
      } else if (error === "email unverified") {
        replace({
          pathname: `/${ut}/auth/email/error`,
          // eslint-disable-next-line object-shorthand
          query: { email: email },
        });
      } else if (status.gf_account_types.includes(userType)) {
        await replace({
          pathname: `/${ut}/auth/sessionful/select`,
          query: params,
        });
      } else if (userType === "admin") {
        await replace({
          pathname: `/${ut}/auth/sessionless`,
          query: params,
        });
      } else {
        await replace({
          pathname: `/${ut}/auth/sessionful/join`,
          query: params,
        });
      }
    })();
  });

  return (
    <AuthFlow>
      <Centered>
        <LoadingSpinner />
      </Centered>
    </AuthFlow>
  );
};

AuthLanding.propTypes = {
  userType: PropTypes.string.isRequired,
};

export default AuthLanding;
